import React from "react"
import JavaImg from "../../../images/Java.svg"
import JavaScriptImg from "../../../images/Javascript.svg"
import ReactNativeImg from "../../../images/React-native.svg"
import KotlinImg from "../../../images/Kotlin.svg"
import NodeJsImg from "../../../images/Node-js.svg"
import AngularImg from "../../../images/Angularjs.svg"
 
const PrimaryTechnologies = () => {
  return (
    <section className="bg-primary text-white py-12">
      <div className="flex flex-col lg:flex-row container mx-auto px-6 items-center">
        <div className="w-full lg:w-3/12">
          <h3 className="text-4xl md:text-5xl lg:text-3xl xl:text-5xl font-bold leading-loose"><span className="text-secondary">Primary</span> Technologies</h3>
        </div>
        <div className="w-full py-12 lg:w-9/12 lg:pl-4">
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-8 text-2xl xl:text-3xl text-center md:text-left">
            <div><img src={JavaImg} alt="JAVA" className="inline-flex" /> JAVA</div>
            <div><img src={JavaScriptImg} alt="JAVASCRIPT" className="inline-flex" /> JAVASCRIPT</div>
            <div><img src={ReactNativeImg} alt="REACT" className="inline-flex" /> REACT</div>
            <div><img src={KotlinImg} alt="KOTLIN" className="inline-flex" /> KOTLIN</div>
            <div><img src={NodeJsImg} alt="NODE JS" className="inline-flex" /> NODE JS</div>
            <div><img src={AngularImg} alt="ANGULAR" className="inline-flex" /> ANGULAR</div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PrimaryTechnologies
